import $ from "jquery";

$.fn.popup = function (trigger, position, hideCallback) {
	return this.each(function () {
		var e = $(this);
		function hide() {
			e.hide();
			if (hideCallback) hideCallback(e);
		}

		if (e.data("ui-popup-attached"))
			return;
		e.data("ui-popup-attached", true);
		e.addClass("ui-popup");
		var trg = typeof trigger === "function" ? trigger(e) : trigger == "parent" ? e.parent() : $(trigger);
		trg.on("click", function (x) {
			if (trg.is(":disabled"))
				return false;
			x.preventDefault();
			if (e.is(":visible")) {
				return hide();
			}
			var pos = $.extend({}, { my: "left top", at: "left bottom", of: this }, position);
			e.show().position(pos);
			/* do not let popup have negative offset */
			var offset = e.offset();
			var jpos = e.position();
			if (offset.left < 0) jpos.left -= offset.left;
			if (offset.top < 0) jpos.top -= offset.top;
			e.css(jpos);
			setTimeout(function () {
				$(document).one("click", hide);
			}, 0);
		});
	});
};